import React from "react";
import { Text } from "@salestrak/ui";
import type { ActivityChange } from "../activity-types";
import { useActivityNoun } from "../activity-context";

/** The entity's own lifecycle row — the line a feed opens (or closes) with.
 *  The verb is the changeset key, so one chunk serves "created this account"
 *  and "updated this account". */
export function CreationChunk({ change }: { change?: ActivityChange }) {
  const noun = useActivityNoun();
  const verb = change?.target.type === "updated" ? "updated" : "created";
  return (
    <Text size="sm">
      {verb} this {noun.toLowerCase()}
    </Text>
  );
}
